import { ReactNode } from 'react'

import Modal from '@ilg-totallymoney/ui/components/Modal'
import Text from '@ilg-totallymoney/ui/components/Text'

const StyledText = ({ children }: { children: ReactNode }) => (
    <Text color="light" variant="100">
        {children}
    </Text>
)

interface LoanTypeModalProps {
    onModalClose: () => void
    showModal: boolean
}

const LoanTypeModal = ({ showModal, onModalClose }: LoanTypeModalProps) => {
    return (
        <Modal
            title="Personal Loan"
            hasHeader={false}
            hasTooltipHeader={true}
            isOpen={showModal}
            onClose={onModalClose}
            isFullScreen={true}
            hasMinHeight={false}
        >
            <StyledText>
                Personal loans, sometimes called unsecured loans, let you borrow
                an agreed amount of money, which is paid directly into your bank
                account. You&apos;ll repay it over a set amount of time in fixed
                monthly instalments, usually with a fixed interest rate.
                Interest rates vary depending on your credit history, and some
                personal loans have a fee if you pay them back early.
            </StyledText>
        </Modal>
    )
}

export default LoanTypeModal
